import React from "react";
import "./BookMove.scss"
import { CardLayout } from "components/cardLayout";
import { CardItem } from "components/cardItem";
import { CardSubItem } from "components/cardSubItem";
import { TextField } from "components/textField";
import { Button } from "components/button";
import { CardTitle } from "components/cardTitle";
import moment from "moment";
import { FormGroup, Validators, FormBuilder, FormControl } from "react-reactive-form";
import { phoneNumberValidator } from "core/utils";
import {createLeadQuery} from "core/services/LeadService"
import { client } from "App";

export interface BookMoveProps {
    onClick?(): void;
}

export interface BookMoveState {
    isValid: boolean;
    amounts:any
}

class BookMove extends React.Component<BookMoveProps, BookMoveState> {
    formGroup: FormGroup = FormBuilder.group(
        {
            name: ['', Validators.required],
            Telephone: ['', phoneNumberValidator],
            onBookMove: ['']
        } 
    );

    constructor(props: BookMoveProps) {
        super(props);
        this.state = {
            isValid: false,
            amounts :JSON.parse(localStorage.getItem("amounts") || '{}')
        };

        this.onValueChanges = this.onValueChanges.bind(this);
        this.formGroup.valueChanges.subscribe(this.onValueChanges)
    }

    componentWillUnmount() {
        this.formGroup.valueChanges.unsubscribe(this.onValueChanges);
    }

    onValueChanges(value: any) {
        if (this.formGroup.valid && !this.state.isValid) {
            this.setState({ isValid: true });
        }
        else if (!this.formGroup.valid && this.state.isValid) {
            this.setState({ isValid: false });
        }
    }

    onBookMove() {
        if (this.props.onClick) {
            this.props.onClick();
        }
        this.addLead()
    }
    addLead() {
        //localStorage.removeItem("leadDetails")
              this.createLead()
                .then(response => {
                    localStorage.setItem("leadDetails",JSON.stringify(response.data.createLead[0]))
                     console.log(response)
                });

        }
    

    async createLead() {
        console.clear();

        var object = JSON.parse(localStorage.getItem("movewith") || '{}');
        console.log(object)
      //  alert(moment(object.MoveDate).format("MM/DD/YYYY"));
        // for coupon
        var coupon = localStorage.getItem("movewith") ==="y"?"y":"";
        // for not sure 
var movingDate = localStorage.getItem("notsure")==="1"?moment().add(15,"days").format("MM/DD/YY"):moment(object.MoveDate).format("MM/DD/YY")
var notSure = localStorage.getItem("notsure")==="1"?"1":"0"
        var LeadInput = {
            firstName: this.formGroup.value.name + '',
            lastName:"",
            telephone: (this.formGroup.value.Telephone) ? this.formGroup.value.Telephone.replace("(", "").replace(")", "").replace("-", "").replace(" ", "") : "",
            email:"Didnotprovide@allmysons.com",
            moveDate:movingDate,
            moveSize:"1",
            originZip:localStorage.getItem("currentZipCode"),
            src:"pricingpagegoogleapt1br",
            destinationZip:"",
            aPIReferenceID:"1",
            canWeText:"true",
            clientIPAddress:"",
            moveType:object.MoveType,
            promoCode:"",
            unitNo:object.Unit,
            address: object.address,
            movingDateNotSure:notSure
          } 
        console.log("LeadInput:" + JSON.stringify(LeadInput));

        return client.query({
            query: createLeadQuery, variables: {
                leadInput: {
                    employeeID: "0",
                    firstName: this.formGroup.value.name + '',
                    lastName:"",
                    telephone: (this.formGroup.value.Telephone) ? this.formGroup.value.Telephone.replace("(", "").replace(")", "-").replace("-", "").replace(" ", "-") : "",
                    email:"Didnotprovide@allmysons.com",
                    moveDate:movingDate,
                   // moveSize:"Apt 1 Bedroom",
                   moveSize:"1",
                    originZip:localStorage.getItem("currentZipCode"),
                    src:"pricingpagegoogleapt1br",
                    destinationZip:"",
                    aPIReferenceID:"1",
                    canWeText:"true",
                    clientIPAddress:"",
                    moveType:object.MoveType,
                    promoCode:"",
                    unitNo:object.Unit,
                    address: object.address,
                    movingDateNotSure:notSure
           
                }
            }
        });
    }
    render() {
        var object = JSON.parse(localStorage.getItem("movewith") || '{}');
        var address = object.address + ", #" + object.Unit
        var weekday = moment(object.MoveDate).format("d")
        var isSuper = parseInt(weekday) <= 3 ? 1 : 0;
        var amounts="0", total=0;
        
        var totalAmt = this.state.amounts.find((item:any)=>item.type==="Total").amount
        var deposit = this.state.amounts.find((item:any)=>item.type==="Deposit").amount

        return (
            <div className="bookmove-container">
            <div className="bookmove-title">         
                 <h1>you’re All Set!</h1>
                </div>
              <div className="bookmove-subtitle">
                    <h2>Let’s review everything before we book your move.</h2>
                </div>
                <div className="bookmove-detail">
                    <CardLayout>
                        <CardItem itemLabel={"Address "} itemValue={"Move Date"} />
                        <CardSubItem rightLabel={address} leftLabel={

                            localStorage.getItem("notsure") === "1" ?
                                "Not Sure"
                                : moment(object.MoveDate).format("MM/DD/YY")} />
                    </CardLayout>
                    <CardLayout>
                        <CardItem itemLabel={"Pricing"} />
                        <CardTitle title={
                            isSuper ?
                                "Super Deal Move"
                                : "Move Details"} value={"$"+Number(totalAmt).toFixed(2)} />
                        <div className="booking-info">
                            <p> - 1 Bedroom Apartment, Local </p>
                        </div>
                    </CardLayout>
                    <div className="secure-booking">
                        <p>To secure and book your move, a deposit of ${Number(deposit).toFixed(2)} is required. Your payment will go towards the total cost of move.</p>
                    </div>
                </div>
                <div>
                    <TextField
                        label={"Name"}
                        keyboardType={"text"}
                        formControl={this.formGroup.get('name') as FormControl}
                    />
                    <TextField
                        label={"Phone"}
                        keyboardType={"tel"}
                        formControl={this.formGroup.get('Telephone') as FormControl}
                        mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                        />
                </div>
                <div className="booking-btn">
                    <Button
                        text={"Pay Deposit"}
                        formControl={this.formGroup.get('onBookMove') as FormControl}
                        formGroup={this.formGroup}
                        onClick={() => this.onBookMove()}
                    />
                </div>
            </div>
        );
    }
}

export default BookMove;